import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { AuthService } from "../base-module/base-service/auth.service";
import { BaseModule } from "../base-module/base.module";
import { ClientesRoutesModule } from "./clientes.routing";

import { FuseWidgetModule } from "@fuse/components/widget/widget.module";
import { NgxChartsModule } from "@swimlane/ngx-charts";

/** Components */
import { AlteraCarteiraComponent } from "./altera-carteira/altera-carteira.component";
import { CadastraSaldoClienteComponent } from "./cadastra-saldo-cliente/cadastra-saldo-cliente.component";
import { CadastroClienteSimplesComponent } from "./cadastro-cliente-simples/cadastro-cliente-simples.component";
import { CadastroCompletoComponent } from "./cadastro-completo/cadastro-completo.component";
import { CadastroHistoricoClienteComponent } from "./cadastro-historico-cliente/cadastro-historico-cliente.component";
import { CadastroRelacionamentoComponent } from "./cadastro-relacionamento/cadastro-relacionamento.component";
import { CadastroCompletoPainelComponent } from "./cliente-dados/cadastro-completo-painel/cadastro-completo-painel.component";
import { FeedbackClienteComponent } from "./cliente-dados/feedback-cliente/feedback-cliente.component";
import { ListaHistoricoClienteComponent } from "./cliente-dados/lista-historico-cliente/lista-historico-cliente.component";
import { PosicaoConsolidadaComponent } from "./cliente-dados/posicao-consolidada/posicao-consolidada.component";
import { ClienteProdutosComponent } from "./cliente-produtos/cliente-produtos.component";
import { ListaCustodiaRvClienteComponent } from "./custodia-rv-cliente/lista-custodia-rv-cliente/lista-custodia-rv-cliente.component";
import { FiltrarClienteComponent } from "./filtrar-cliente/filtrar-cliente.component";
import { FiltrarRelacionamentoComponent } from "./filtrar-relacionamento/filtrar-relacionamento.component";
import { FiltroHistoricoClienteComponent } from "./filtro-historico-cliente/filtro-historico-cliente.component";
import { ListaHistoricoRelacionamentoComponent } from "./lista-historico-relacionamento/lista-historico-relacionamento.component";
import { ListaSaldoClienteComponent } from "./lista-saldo-cliente/lista-saldo-cliente.component";
import { ListaComponent } from "./lista/lista.component";
import { CadastroProdutoComponent } from "./produtos/cadastro-produto/cadastro-produto.component";
import { ClienteFundoInvestimentoComponent } from "./produtos/cliente-fundo-investimento/cliente-fundo-investimento.component";
import { ClientePrevidenciaComponent } from "./produtos/cliente-previdencia/cliente-previdencia.component";
import { ClienteRendaFixaComponent } from "./produtos/cliente-renda-fixa/cliente-renda-fixa.component";
import { ClienteRendaVariavelComponent } from "./produtos/cliente-renda-variavel/cliente-renda-variavel.component";
import { CoeComponent } from "./produtos/coe/coe.component";
import { UploadHistoricoClienteComponent } from "./upload-historico-cliente/upload-historico-cliente.component";
// import { TimeLineClienteComponent } from './time-line-cliente/time-line-cliente.component';
import { CadastroEstruturaFamiliarComponent } from "app/clientes/cliente-dados/estrutura-familiar/cadastro-estrutura-familiar/cadastro-estrutura-familiar.component";
import { ListaEstruturaFamiliarComponent } from "app/clientes/cliente-dados/estrutura-familiar/lista-estrutura-familiar/lista-estrutura-familiar.component";

/** Services */
import { OrigemService } from "app/auxiliares/services/origem-cliente.service";
import { PrimeiroContatoService } from "app/auxiliares/services/primeiro-contato.service";
import { ProfissaoService } from "app/auxiliares/services/profissao.service";
import { SituacaoTributariaService } from "app/auxiliares/services/situacao-tributaria.service";
import { EnderecoService } from "../base-module/base-service/endereco.service";
import { EmpresaService } from "../empresas/services/empresa.service";
import { TarefasRespostaUsuarioService } from "../lista-atividades/services/lista-atividades-tarefas-respostas.service";
import { CarteiraService } from "./services/carteira.service";
import { ClienteCarteiraHistoricoService } from "./services/cliente-carteira-historico.service";
import { ClienteFundoInvestimentoService } from "./services/cliente-fundo-investimento.service";
import { ClienteHistoricoService } from "./services/cliente-historico.service";
import { ClientePerfilService } from "./services/cliente-perfil.service";
import { ClienteRelacionentoService } from "./services/cliente-relacionamento.service";
import { ClienteService } from "./services/cliente.service";
import { EstadoCivilService } from "./services/estado-civil.service";
import { FeedbackService } from "./services/feedback.service";
import { SaldoClientesService } from "./services/saldo-clientes.service";

import { ConsorcioModule } from "app/consorcio/consorcio.module";
import { MovimentacaoModule } from "app/movimentacao/movimentacao.module";
import { PrevidenciaModule } from "app/previdencia/previdencia.module";
import { RendaFixaModule } from "app/renda-fixa/renda-fixa.module";
import { RendaVariavelModule } from "app/renda-variavel/renda-variavel.module";
import { CadastroDadosFinanceiroComponent } from "./cliente-dados/cadastro-dados-financeiro/cadastro-dados-financeiro.component";
import { ClienteRendaVariavelPerfilComponent } from "./cliente-dados/cliente-renda-variavel-perfil/cliente-renda-variavel-perfil.component";
import { EvolucaoPatrimonialComponent } from "./cliente-dados/evolucao-patrimonial/evolucao-patrimonial.component";
import { HistoricoMovimentacaoComponent } from "./cliente-dados/historico-movimentacao/historico-movimentacao.component";
import { InvestimentosComponent } from "./cliente-dados/investimentos/investimentos.component";
import { ModalDetailNnmComponent } from "./cliente-dados/modal-detail-nnm/modal-detail-nnm.component";
import { ListaCustodiaDerivativosComponent } from "./custodia-rv-cliente/lista-custodia-derivativos/lista-custodia-derivativos.component";
import { ListaCustodiaProventosComponent } from "./custodia-rv-cliente/lista-custodia-proventos/lista-custodia-proventos.component";
import { ListaEstrategiaCustodiaComponent } from "./custodia-rv-cliente/lista-estrategia-custodia/lista-estrategia-custodia.component";
// import { NgxHorizontalTimelineModule } from "ngx-horizontal-timeline"; //todo: verificar
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FileUploadModule } from "ng2-file-upload";
import { TipoOportunidadeService } from "../auxiliares/services/tipo-oportunidade-service";
import { CadastroClienteCustosComponent } from "./cadastro-cliente-custos/cadastro-cliente-custos.component";
import { CadastroClienteIndicacaoComponent } from "./cadastro-cliente-indicacao/cadastro-cliente-indicacao.component";
import { CadastroClientePatrimoniosComponent } from "./cadastro-cliente-patrimonio/cadastro-cliente-patrimonio.component";
import { CadastroClienteProjetosComponent } from "./cadastro-cliente-projeto/cadastro-cliente-projeto.component";
import { CadastroClienteReceitasComponent } from "./cadastro-cliente-receitas/cadastro-cliente-receitas.component";
import { CadastroCompletoStepperComponent } from "./cadastro-completo-stepper/cadastro-completo-stepper.component";
import { CadastroOportunidadeComponent } from "./cadastro-oportunidade/cadastro-oportunidade.component";
import { CadastroRelacionamentoClienteComponent } from "./cadastro-relacionamento-cliente/cadastro-relacionamento-cliente.component";
import { CadastroTipoCustoComponent } from "./cadastro-tipo-custo/cadastro-tipo-custo.component";
import { CadastroTipoPatrimonioComponent } from "./cadastro-tipo-patrimonio/cadastro-tipo-patrimonio.component";
import { CadastroTipoReceitaComponent } from "./cadastro-tipo-receita/cadastro-tipo-receita.component";
import { FiltrarGestaoRelacionamentoComponent } from "./filtrar-gestao-relacionamento/filtrar-gestao-relacionamento.component";
import { GestaoRelacionamentoClienteComponent } from "./gestao-relacionamento-cliente/gestao-relacionamento-cliente.component";
import { ListaClienteCustoComponent } from "./lista-cliente-custo/lista-cliente-custo.component";
import { ListaClienteIndicacaoComponent } from "./lista-cliente-indicacao/lista-cliente-indicacao.component";
import { ListaClientePatrimonioComponent } from "./lista-cliente-patrimonio/lista-cliente-patrimonio.component";
import { ListaClienteProjetoComponent } from "./lista-cliente-projeto/lista-cliente-projeto.component";
import { ListaClienteReceitaComponent } from "./lista-cliente-receita/lista-cliente-receita.component";
import { ListaGestaoRelacionamentoComponent } from "./lista-gestao-relacionamento/lista-gestao-relacionamento.component";
import { ListaLimitadaComponent } from "./lista-limita/lista-limitada.component";
import { ListaOportunidadeClienteComponent } from "./lista-oportunidade-cliente/lista-oportunidade-cliente.component";
import { ListaTipoCustoComponent } from "./lista-tipo-custo/lista-tipo-custo.component";
import { ListaTipoPatrimonioComponent } from "./lista-tipo-patrimonio/lista-tipo-patrimonio.component";
import { ListaTipoReceitaComponent } from "./lista-tipo-receita/lista-tipo-receita.component";
import { ModalRelacionamentoComponent } from "./modal-relacionamento/modal-relacionamento.component";
import { ClienteCustoService } from "./services/cliente-custo.service";
import { ClienteIndicacaoService } from "./services/cliente-indicacao.service";
import { ClienteOportunidadeService } from "./services/cliente-oportunidade.service";
import { ClientePatrimonioService } from "./services/cliente-patrimonio.service";
import { ClienteProjetoService } from "./services/cliente-projeto.service";
import { ClienteReceitaService } from "./services/cliente-receita.service";
import { TipoCustoService } from "./services/tipo-custo.service";
import { TipoPatrimonioService } from "./services/tipo-patrimonio.service";
import { TipoReceitaService } from "./services/tipo-receita.service";

@NgModule({
    imports: [
        CommonModule,
        MatStepperModule,
        ClientesRoutesModule,
        RendaFixaModule,
        PrevidenciaModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatGridListModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatListModule,
        MatAutocompleteModule,
        BaseModule,
        FileUploadModule,
        MatSelectModule,
        MatOptionModule,
        MatTabsModule,
        MatRadioModule,
        MatDatepickerModule,
        CurrencyMaskModule,
        MatMenuModule,
        MatChipsModule,
        NgxChartsModule,
        FuseWidgetModule,
        DragDropModule,
        MatExpansionModule,
        MovimentacaoModule,
        RendaVariavelModule,
        ConsorcioModule,
        MatTableModule,
        MatButtonToggleModule,
        // MatStepperModule, //TODO: verificar dependencia
        MatSlideToggleModule,
        MatDialogModule,
        NgxMaskDirective,
        NgxMaskPipe,
    ],
    declarations: [
        ListaComponent,
        CadastroCompletoComponent,
        CadastroCompletoStepperComponent,
        FiltrarClienteComponent,
        CadastroRelacionamentoComponent,
        FiltrarRelacionamentoComponent,
        AlteraCarteiraComponent,
        PosicaoConsolidadaComponent,
        FeedbackClienteComponent,
        ListaSaldoClienteComponent,
        CadastraSaldoClienteComponent,
        ListaHistoricoClienteComponent,
        CadastroHistoricoClienteComponent,
        FiltroHistoricoClienteComponent,
        UploadHistoricoClienteComponent,
        ListaHistoricoRelacionamentoComponent,
        ClienteProdutosComponent,
        CoeComponent,
        ClienteRendaFixaComponent,
        CadastroProdutoComponent,
        ClientePrevidenciaComponent,
        ClienteFundoInvestimentoComponent,
        ClienteRendaVariavelComponent,
        CadastroCompletoPainelComponent,
        // TimeLineClienteComponent,
        CadastroClienteSimplesComponent,
        ListaCustodiaRvClienteComponent,
        ListaEstrategiaCustodiaComponent,
        ListaCustodiaDerivativosComponent,
        ListaEstruturaFamiliarComponent,
        ListaCustodiaProventosComponent,
        InvestimentosComponent,
        ClienteRendaVariavelPerfilComponent,
        CadastroDadosFinanceiroComponent,
        CadastroEstruturaFamiliarComponent,
        EvolucaoPatrimonialComponent,
        HistoricoMovimentacaoComponent,
        ModalDetailNnmComponent,
        ModalRelacionamentoComponent,
        CadastroRelacionamentoClienteComponent,
        GestaoRelacionamentoClienteComponent,
        ListaOportunidadeClienteComponent,
        CadastroOportunidadeComponent,
        ListaLimitadaComponent,
        ListaTipoCustoComponent,
        CadastroTipoCustoComponent,
        ListaTipoReceitaComponent,
        CadastroTipoReceitaComponent,
        ListaTipoPatrimonioComponent,
        CadastroTipoPatrimonioComponent,
        ListaClienteCustoComponent,
        CadastroClienteCustosComponent,
        ListaClienteReceitaComponent,
        CadastroClienteReceitasComponent,
        ListaClientePatrimonioComponent,
        CadastroClientePatrimoniosComponent,
        ListaClienteProjetoComponent,
        CadastroClienteProjetosComponent,
        ListaClienteIndicacaoComponent,
        CadastroClienteIndicacaoComponent,
        ListaGestaoRelacionamentoComponent,
        FiltrarGestaoRelacionamentoComponent,
    ],
    providers: [
        AuthService,
        ClienteService,
        EnderecoService,
        EmpresaService,
        ClienteRelacionentoService,
        CarteiraService,
        ClientePerfilService,
        FeedbackService,
        SaldoClientesService,
        ClienteHistoricoService,
        EstadoCivilService,
        ClienteFundoInvestimentoService,
        ClienteCarteiraHistoricoService,
        ProfissaoService,
        SituacaoTributariaService,
        PrimeiroContatoService,
        OrigemService,
        TipoOportunidadeService,
        ClienteOportunidadeService,
        TipoCustoService,
        TipoReceitaService,
        TipoPatrimonioService,
        ClienteCustoService,
        ClienteReceitaService,
        ClientePatrimonioService,
        ClienteProjetoService,
        ClienteIndicacaoService,
        TarefasRespostaUsuarioService,
        provideNgxMask(),
    ],
    exports: [
        CadastroClienteSimplesComponent,
        FiltrarClienteComponent,
        ListaEstruturaFamiliarComponent,
        CadastroEstruturaFamiliarComponent,
        ModalDetailNnmComponent,
        GestaoRelacionamentoClienteComponent,
        CadastroOportunidadeComponent,
        ListaTipoCustoComponent,
        CadastroTipoCustoComponent,
        ListaTipoReceitaComponent,
        CadastroTipoReceitaComponent,
        ListaTipoPatrimonioComponent,
        CadastroTipoPatrimonioComponent,
        ListaClienteCustoComponent,
        CadastroClienteCustosComponent,
        ListaClienteReceitaComponent,
        CadastroClienteReceitasComponent,
        ListaClientePatrimonioComponent,
        CadastroClientePatrimoniosComponent,
        ListaClienteProjetoComponent,
        CadastroClienteProjetosComponent,
        ListaClienteIndicacaoComponent,
        CadastroClienteIndicacaoComponent,
    ],
})
export class ClientesModule {}
